import { Tag } from "@blueprintjs/core";
import { segmentTrackCustomInjectionDialogOpened } from "analytics/analyticTrackEvents";
import { useMapViewRoutingMetadata } from "contexts/RoutingMetadataContext";
import React from "react";
import { BusId } from "types/busType";
import { ENERGY_RESOURCE_TYPE, ResourceType } from "types/resourceType";
import { FacilityId } from "types/selectedFacility";
import { getPillIntent, getSizeLabel, LabelStyleType } from "./labels";

import "./AvailableTag.scss";

type AvailableTagProps = {
    readonly size: number;
    readonly editedSize?: number;
    readonly onClick?: () => void;
    readonly selectedId?: BusId | FacilityId;
    readonly resourceType: ResourceType;
    readonly labelStyle: LabelStyleType;
    readonly minimal?: boolean;
};

const AvailableTag: React.FC<AvailableTagProps> = (props) => {
    const {
        size,
        editedSize,
        onClick,
        selectedId,
        resourceType,
        labelStyle,
        minimal
    } = props;

    const { componentConfig } = useMapViewRoutingMetadata();

    let pillOnClick;
    if (onClick && selectedId) {
        pillOnClick = () => {
            segmentTrackCustomInjectionDialogOpened(selectedId);
            onClick();
        };
    }

    // Show a descriptive label instead of the raw MW value in edge cases (CAISO)
    const noConstraintsDeliverable = componentConfig.noConstraintsDeliverable;
    const showNoConstraintsLabel =
        noConstraintsDeliverable !== undefined &&
        resourceType === ENERGY_RESOURCE_TYPE &&
        size === noConstraintsDeliverable.sentinelMw;

    if (showNoConstraintsLabel) {
        return (
            <Tag
                round={true}
                minimal={minimal}
                intent={getPillIntent(resourceType, labelStyle)}
                interactive={pillOnClick !== undefined}
                onClick={pillOnClick}
            >
                {noConstraintsDeliverable.label}
            </Tag>
        );
    }

    return (
        <Tag
            round={true}
            minimal={minimal}
            intent={getPillIntent(resourceType, labelStyle)}
            interactive={pillOnClick !== undefined}
            onClick={pillOnClick}
        >
            <span
                className={
                    size !== editedSize && editedSize !== undefined
                        ? "AvailableTag-default-crossed"
                        : ""
                }
            >
                {size.toFixed(0)}
            </span>
            {size !== editedSize && editedSize !== undefined && (
                <span>{` → ${editedSize.toFixed(0)}`}</span>
            )}{" "}
            {getSizeLabel(resourceType, labelStyle)}
        </Tag>
    );
};

export default AvailableTag;
